import md5 from "md5";
import http from "@/http-common";

const getAll = async () => {
  return await http
    .get("/notification")
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll
};
